import { useContext } from 'react'
import { useWatch } from 'react-hook-form'

import { SelectOption } from 'components/Select'
import { AddEditPageContext } from 'features/inventory/page/contexts/AddEditPageContext'
import { Domain } from 'features/inventory/types/domain'
import { FormVariant } from 'types/formVariant'
import { DomainSlice } from '../../hooks/useGetDomainsForSelect'
import { CommonSchema } from '../../schemas/commonSchema'

type Props = {
  domains: SelectOption<DomainSlice>[]
  variant: FormVariant
}

type Return = {
  overriddenByYieldbird?: Domain['overriddenByYieldbird']
  pubAdsServiceRefresh: Domain['pubAdsServiceRefresh'] | undefined
}

export const usePubAdsServiceRefresh = ({ domains, variant }: Props): Return => {
  const { page } = useContext(AddEditPageContext)
  const { domainId } = useWatch<CommonSchema>()

  let pubAdsServiceRefresh: Domain['pubAdsServiceRefresh'] | undefined
  let overriddenByYieldbird: Domain['overriddenByYieldbird'] | undefined

  switch (variant) {
    case 'add': {
      const selectedDomain: SelectOption<DomainSlice> | undefined = domains.find(
        ({ value }: SelectOption<DomainSlice>) => value === domainId,
      )

      if (selectedDomain) {
        pubAdsServiceRefresh = selectedDomain.rawData?.pubAdsServiceRefresh
        overriddenByYieldbird = selectedDomain.rawData?.overriddenByYieldbird
      }
      break
    }
    case 'edit': {
      if (page === undefined) {
        throw Error('Page should be available')
      }

      pubAdsServiceRefresh = page.domain.pubAdsServiceRefresh
      overriddenByYieldbird = page.domain.overriddenByYieldbird
      break
    }
  }

  return {
    overriddenByYieldbird,
    pubAdsServiceRefresh,
  }
}
